import { createMotionComponent } from "@fluentui/react-components";

export const FadeEnter = createMotionComponent({
  keyframes: [{ opacity: 0 }, { opacity: 1 }],
  duration: 1000,
  iterations: 1,
});
